import { styled } from '@linaria/react';
import { useState, useEffect } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import { IconButton, TwitterIcon, LinkedInIcon, YouTubeIcon, GithubIcon, TikTokIcon } from '@vidbaseapp/styleguide';
export const StyledLandingFooter = /*#__PURE__*/styled("footer")({
  name: "StyledLandingFooter",
  class: "s1qkwdjf"
});
export interface ILandingFooter {
  year?: number;
}
export const LandingFooter = ({
  year = 2022
}: ILandingFooter) => {
  return <StyledLandingFooter>
			<h2 className="srOnly">Footer</h2>
			<div className="content">
				<div className="footer-primary">&nbsp;</div>
				<div className="footer-secondary">
					<div className="footer-copyright">© {year} Vidbase, Inc. All rights reserved.</div>
					<div className="footer-social">
						<ul>
							<li>
								<IconButton as="a" href="https://twitter.com/VidbaseApp" alt="VidbaseApp on Twitter">
									<TwitterIcon size="2rem" color="var(--clr-gray)" enableFilters={false} />
								</IconButton>
							</li>
							<li>
								<IconButton as="a" // href="https://www.youtube.com/channel/UCRa6hy6J79kGFLr_gvlEZGw"
              href="https://www.youtube.com/channel/UCguQr6z-wZB1Fd0oWMtPO_g" alt="Vidbase on YouTube">
									<YouTubeIcon size="2rem" color="var(--clr-gray)" enableFilters={false} />
								</IconButton>
							</li>
							<li>
								<IconButton as="a" href="https://www.tiktok.com/@vidbase" alt="Vidbase on TikTok">
									<TikTokIcon size="2rem" color="var(--clr-gray)" enableFilters={false} />
								</IconButton>
							</li>
							<li>
								<IconButton as="a" href="https://www.linkedin.com/company/vidbase" alt="Vidbase on LinkedIn">
									<LinkedInIcon size="2rem" color="var(--clr-gray)" enableFilters={false} />
								</IconButton>
							</li>
							<li>
								<IconButton as="a" href="https://github.com/vidbase" alt="Vidbase on Github">
									<GithubIcon size="2rem" color="var(--clr-gray)" enableFilters={false} />
								</IconButton>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</StyledLandingFooter>;
};

require("./LandingFooter.linaria.module.css!=!../../../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./LandingFooter.tsx");